<template>
  <div>
    <div v-if="!payload" class="flex flex-center" style="padding: 20px 0;">
      <van-loading size="80px" vertical>数据加载中...</van-loading>
    </div>
    <template v-else>
      <template v-if="!payload.volunteer">
        <div class="com-page-title">
          <div class="inner">加入我们</div>
        </div>
        <div class="com-card">
          <div class="com-card-title">义工招募</div>
          <div class="com-card-content">
            <div class="com-form-wrap">
              <div class="text-wrap com-text-justify">
                <div v-html="$relaceToBr(payload.ask.find(it => it.type == 1).content)" />
              </div>
            </div>
          </div>
        </div>
        <div class="com-card">
          <div class="com-card-title">加入要求</div>
          <div class="com-card-content">
            <div class="com-form-wrap">
              <div class="text-wrap com-text-justify">
                <div v-html="$relaceToBr(payload.ask.find(it => it.type == 2).content)" />
              </div>
            </div>
          </div>
        </div>
        <div class="com-card">
          <div class="com-card-title">如何加入</div>
          <div class="com-card-content">
            <div class="com-form-wrap">
              <div class="text-wrap com-text-justify">
                <div v-html="$relaceToBr(payload.ask.find(it => it.type == 3).content)" />
              </div>
            </div>
          </div>
        </div>
        <div class="com-card">
          <div class="com-card-title">信息登记<span style="color: red;font-size: 12px">（带 * 为必填项）</span></div>
          <div class="com-card-content">
            <div class="com-form-wrap">
              <van-form class="com-form-vertical" ref="form" colon>
                <van-field
                  v-model="form.name"
                  :border="false"
                  label="姓名"
                  placeholder="请填写姓名"
                  required
                  :rules="[{ required: true, trigger: 'onBlur', message: '请填写姓名' }]"
                >
                  <template #left-icon>（需与身份证上一致）</template>
                </van-field>
                <van-field
                  v-model="form.idCard"
                  :border="false"
                  label="身份证号"
                  placeholder="请输入身份证号"
                  required
                  maxlength="18"
                  :rules="[{ required: true, trigger: 'onBlur', message: '请输入身份证号' }, { validator: $validate.idCard, message: '请填写正确的身份证号' }]"
                />
                <van-field
                  class="no-input"
                  :border="false"
                  label="性别"
                  required
                  :rules="[{ required: true, trigger: 'onChange', message: '请选择' }]"
                >
                  <template #input>
                    <DictionaryRadio v-model="form.sex" typeCode="system_sex" />
                  </template>
                </van-field>
                <van-field
                  v-model="form.nativePlace"
                  :border="false"
                  label="籍贯"
                  placeholder="请输入籍贯"
                  required
                  :rules="[{ required: true, trigger: 'onBlur', message: '请输入籍贯' }]"
                />
                <van-field
                  v-model="form.nation"
                  :border="false"
                  label="民族"
                  placeholder="请输入民族"
                  required
                  :rules="[{ required: true, trigger: 'onBlur', message: '请输入民族' }]"
                />
                <van-field
                  class="no-input"
                  :border="false"
                  label="婚姻状况"
                  required
                  :rules="[{ required: true, trigger: 'onChange', message: '请选择' }]"
                >
                  <template #input>
                    <DictionaryRadio v-model="form.maritalStatus" typeCode="system_marital_status" />
                  </template>
                </van-field>
                <van-field
                  class="no-input"
                  :border="false"
                  label="健康状况"
                  required
                  :rules="[{ required: true, trigger: 'onChange', message: '请选择' }]"
                >
                  <template #input>
                    <DictionaryRadio v-model="form.health" typeCode="system_health" />
                  </template>
                </van-field>
                <van-field
                  class="no-input"
                  :border="false"
                  label="学历"
                  required
                  :rules="[{ required: true, trigger: 'onChange', message: '请选择' }]"
                >
                  <template #input>
                    <DictionaryRadio v-model="form.education" typeCode="system_education" />
                  </template>
                </van-field>
                <!-- <template v-if="form.education && form.education != 'none'">
                  <van-field
                    v-model="form.maxEdu"
                    :border="false"
                    label="最高学历"
                    placeholder="请填写最高学历"
                    required
                    :rules="[{ required: true, trigger: 'onBlur', message: '请填写最高学历' }]"
                  />
                  <van-field
                    v-model="form.institution"
                    :border="false"
                    label="就读院校"
                    placeholder="请填写就读院校"
                    required
                    :rules="[{ required: true, trigger: 'onBlur', message: '请填写就读院校' }]"
                  />
                  <van-field
                    v-model="form.speciality"
                    :border="false"
                    label="专业"
                    placeholder="请填写专业"
                    required
                    :rules="[{ required: true, trigger: 'onBlur', message: '请填写专业' }]"
                  />
                </template> -->
                <van-field
                  class="no-input"
                  :border="false"
                  label="工作状态"
                  required
                  :rules="[{ required: true, trigger: 'onChange', message: '请选择' }]"
                >
                  <template #input>
                    <DictionaryRadio v-model="form.workStatus" typeCode="system_work_status" />
                  </template>
                </van-field>
                <van-field
                  v-model="form.workUnit"
                  :border="false"
                  label="从事工作是"
                  placeholder="请填写从事工作或“无”"
                  required
                  :rules="[{ required: true, trigger: 'onBlur', message: '请填写从事工作' }]"
                />
                <van-field
                  class="no-input"
                  :border="false"
                  label="技能专长（可多选）"
                  required
                  :rules="[{ required: true, trigger: 'onChange', message: '请选择' }]"
                >
                  <template #input>
                    <DictionaryCheckbox v-model="form.skill" typeCode="system_skill" />
                  </template>
                </van-field>
                <van-field
                  v-if="form.skill.includes('other')"
                  style="padding-top: 0;"
                  v-model="form.skillItem"
                  :border="false"
                  placeholder="其他技能描述"
                  required
                  :rules="[{ required: true, trigger: 'onBlur', message: '请填写技能描述' }]"
                />
                <van-field
                  class="no-input"
                  :border="false"
                  label="是否受戒"
                  required
                  :rules="[{ required: true, trigger: 'onChange', message: '请选择' }]"
                >
                  <template #input>
                    <DictionaryRadio v-model="form.initiated" typeCode="system_initiated" />
                  </template>
                </van-field>
                <van-field
                  class="no-input"
                  :border="false"
                  label="是否发长远心护持道场"
                  required
                  :rules="[{ required: true, trigger: 'onChange', message: '请选择' }]"
                >
                  <template #input>
                    <DictionaryRadio v-model="form.longDojo" typeCode="system_long_dojo" />
                  </template>
                </van-field>
                <van-field
                  class="no-input"
                  :border="false"
                  label="是否可以固定义工时间（可多选）"
                  required
                  :rules="[{ required: true, trigger: 'onChange', message: '请选择' }]"
                >
                  <template #input>
                    <DictionaryCheckbox v-model="form.fixTime" typeCode="system_fixTime" />
                  </template>
                </van-field>
                <van-divider content-position="center">联络方式</van-divider>
                <van-field
                  style="padding-top: 0 !important"
                  v-model="form.mobile"
                  :border="false"
                  label="本人手机号"
                  placeholder="请填写本人手机号"
                  required
                  :rules="[{ required: true, trigger: 'onBlur', message: '请填写本人手机号' }, { validator: $validate.phone, message: '手机号格式不正确' }]"
                />
                <van-field
                  v-model="form.address"
                  :border="false"
                  label="本人现居住址"
                  placeholder="请填写本人现居住址"
                  required
                  :rules="[{ required: true, trigger: 'onBlur', message: '请填写本人现居住址' }]"
                />
                <van-field
                  v-model="form.emergencyContact"
                  :border="false"
                  label="紧急联络人"
                  placeholder="请填写紧急联络人"
                  required
                  :rules="[{ required: true, trigger: 'onBlur', message: '请填写紧急联络人' }]"
                />
                <van-field
                  v-model="form.emergencyContactMobile"
                  :border="false"
                  label="紧急联络人电话"
                  placeholder="请填写紧急联络人电话"
                  required
                  :rules="emergencyMobileValid"
                />
              </van-form>
            </div>
          </div>
        </div>
        <div class="com-card">
          <div class="com-card-title">义工公约</div>
          <div class="com-card-content">
            <div class="com-form-wrap">
              <div class="text-wrap com-text-justify">
                <div v-html="$relaceToBr(payload.ask.find(it => it.type == 4).content)" />
              </div>
            </div>
          </div>
        </div>
        <div class="com-card">
          <div class="com-card-content">
            <van-checkbox shape="square" v-model="form.checked">我已仔细阅读并充分了解上述规则</van-checkbox>
            <van-space />
            <div class="com-form-submit">
              <DefaultBtn @click="submit">提交</DefaultBtn>
            </div>
          </div>
        </div>
      </template>
      <van-empty description="我们已收到您的申请，请静候通知🙏" v-else>
        <template #image>
          <van-icon name="passed" color="#67c23a" size="10em" />
        </template>
      </van-empty>
    </template>
  </div>
</template>

<script>
import { Toast } from 'vant'
import DictionaryRadio from '@/components/common/DictionaryRadio.vue'
import DictionaryCheckbox from '@/components/common/DictionaryCheckbox.vue'
export default {
  components: { DictionaryRadio, DictionaryCheckbox },
  data () {
    const _this = this
    return {
      payload: null,
      form: {
        sex: '',
        skill: [],
        maritalStatus: '',
        idCard: '',
        checked: false
      },
      emergencyMobileValid: [
        { required: true, trigger: 'onBlur', message: '请填写紧急联络人电话' },
        { validator: _this.$validate.phone, message: '手机号格式不正确' },
        {
          validator (v) {
            return v && v !== _this.form.mobile
          },
          message: '紧急联络人不能与本人手机号一致'
        }
      ]
    }
  },
  created () {
    this.getRecruitStatus()
  },
  methods: {
    submit () {
      // 表单验证
      this.$refs.form.validate().then(async err => {
        if (!err) {
          if (this.form.checked) {
            const toast = Toast.loading({
              duration: 0,
              forbidClick: true,
            })
            const res = await this.$joinApi.submitRecruit({
              ...this.form,
              skill: this.form.skill.join(','),
              fixTime: this.form.fixTime.join(',')
            })
            toast.close()
            if (res.success) {
              this.getRecruitStatus()
            } else {
              Toast.fail(res.errMessage)
            }
          } else {
            this.$toast('请仔细阅读并充分了解上述规则')
          }
        }
      }).catch(() => {})
    },
    // 查询申请状态和文案内容
    async getRecruitStatus () {
      const { data } = await this.$joinApi.getRecruitStatus()
      this.payload = data
    }
  }
}
</script>